import type { FC, Ref } from "react";
import { type FAQItemRecord, FAQList } from "@huub-web/shared";
import { type UIAction, useActions } from "@huub-web/ui";

export type FAQListTemplateProps = {
  title: string;
  items: {
    title: string;
    slug: string;
    summary: string;
    content: string;
    action?: UIAction;
  }[];
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

/**
 * FAQListTemplate displays a list of FAQ items in a category.
 */
export const FAQListTemplate: FC<FAQListTemplateProps> = ({
  title,
  items,
  ref,
}) => {
  const { handleAction } = useActions();

  const parsedItems: FAQItemRecord[] = items.map((item) => ({
    ...item,
    onClick: () => {
      if (item.action) {
        handleAction(item.action);
      }
    },
  }));

  return <FAQList ref={ref} title={title} items={parsedItems} />;
};
